import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AuthenticatorManager } from "../../components/list/AuthenticatorList";
import { CSAuthenticatorManager } from "../../components/list/CSAuthenticatorList";
import { BiometricRegistration } from "../../components/register/AuthenticatorRegister";

import CommonHeader from '../Header/CommonHeader';
import CommonFooter from '../Footer/CommonFooter';
import { PageTitle } from "../../common/PageTitle";

import Keycloak from 'keycloak-js';
import KeycloakState from '../../KeycloakState';
import { useState, useEffect } from 'react'
import axios from "axios";

type Props = {}

const basepath = "/auth_device" 
const boBasepath = `${basepath}/bo`

const RouterRoot: React.FC<Props> = (props) => {
  const kcConfig = {
    realm: "so-net",
    url:`${window.location.origin}/iam/auth/`,
    clientId:"id.so-net.ne.jp/auth_device/"
  }
  // 開発環境用のKeycloak設定
  if (window.location.host.startsWith("localhost")) {
    kcConfig.realm = "Demo"
    kcConfig.url = "https://admin.dev.id.so-net.co.jp/iam/auth"
    kcConfig.clientId = "localhost"
  }
  const keycloak = Keycloak(kcConfig);

  const [keycloakState, setKeycloakState] = useState<KeycloakState>({keycloak: null, authenticated: false});

  // keycloakインスタンス の createLoginUrl関数 を上書き
  const queryParams = new URLSearchParams(window.location.search);
  const fidoDisableParam = queryParams.get("fido_login_disable");
  if (fidoDisableParam !== null) {
    const keycloakDelegateInstance = Keycloak(kcConfig);
    keycloak.createLoginUrl = (options): string => {
      keycloakDelegateInstance.init({});
      return keycloakDelegateInstance.createLoginUrl() + `&fido_login_disable=${fidoDisableParam}`
    }
  }

  const pathname = window.location.pathname;
  useEffect(() => {
    if(!pathname.startsWith(boBasepath)) {
      keycloak.init({onLoad: 'login-required'})
        .then((authenticated) => {
          setKeycloakState({keycloak: keycloak, authenticated: authenticated});
          console.log(`Authenticated:${authenticated}`);
          console.log(`${keycloak}`);
          axios.defaults.headers.common['Authorization'] = `Bearer ${keycloak.token}`;
        }
      );
    }
  },[]);
  // Backofficeのパスの場合は認証不要
  if (pathname.startsWith(boBasepath)) {
    return (
      <Router basename={basepath}>
          <PageWrapper />
      </Router>
    );
  }
  // Backoffice以外のパスの場合にはkeycloakによる認証が通っている場合のみ表示
  if (keycloakState.keycloak !== null) {
      if (keycloakState.authenticated) {
          return (
              <Router basename={basepath}>
                  <PageWrapper />
              </Router>
          );
      }
      return (
          <div>Unable to authenticate</div>
      )
  }
  console.log("Intializing")
  return (
    <>
      <CommonHeader />
        <div>
           <PageTitle
             text="ページを移動しています。少々お待ちください。"
             title="ページ移動中"
           />
        </div>
      <CommonFooter/>
    </>
  )
}

const PageWrapper = () => {
  let location = useLocation();
  let systemId = new URLSearchParams(location.search).get("systemId");
  if (systemId) {
    sessionStorage.setItem("systemId", systemId);
  }
  useEffect(() => {
    var hash = window.decodeURIComponent(window.location.hash);
    if (hash) {
      var element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  },[]);

  return (
    <Switch>
      <Redirect exact from="/" to="/authenticator-manager" />
      {PageSetting.map((setting, index) => {
        return (
          <Route path={setting.path} exact={true} key={setting.path}>
            <>{setting.component}</>
          </Route>
        );
      })}
    </Switch>
  );
};

type PageSetting = {
  path: string;
  component: React.ReactNode;
  title: string;
};

// TODO: ページが増えたら設定箇所を再検討する
const PageSetting: PageSetting[] = [
  {
    path: "/bio-registration",
    component: <BiometricRegistration />,
    title: "生体認証の登録",
  },
  {
    path: "/authenticator-manager",
    component: <AuthenticatorManager />,
    title: "生体認証ログイン設定",
  },
  {
    path: "/bo/authenticator-manager",
    component: <CSAuthenticatorManager />,
    title: "生体認証ログイン設定（CS用） | ログイン | So-net",
  },
];

export default RouterRoot;
